import { render, staticRenderFns } from "./ClienteDetalhes.vue?vue&type=template&id=9267b1fe&"
import script from "./ClienteDetalhes.vue?vue&type=script&lang=js&"
export * from "./ClienteDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports